import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);
const TOKEN_KEY = "sos_token";

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem(TOKEN_KEY);
        if (!token) {
            setLoading(false);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => localStorage.removeItem(TOKEN_KEY))
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem(TOKEN_KEY, data.token);
        setUser({ email: data.email, name: data.name, role: data.role });
        return data;
    };

    const register = async (name, email, password, phone) => {
        const { data } = await api.post("/auth/register", { name, email, password, phone });
        localStorage.setItem(TOKEN_KEY, data.token);
        setUser({ email: data.email, name: data.name, role: data.role });
        return data;
    };

    const loginWithGoogleSession = async (sessionId) => {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem(TOKEN_KEY, data.token);
        setUser({ email: data.email, name: data.name, role: data.role, picture: data.picture });
        return data;
    };

    const logout = () => {
        localStorage.removeItem(TOKEN_KEY);
        setUser(null);
    };

    const isAdmin = user?.role === "admin";
    const isCustomer = user?.role === "customer";

    return (
        <AuthContext.Provider value={{ user, isAdmin, isCustomer, login, register, logout, loading, loginWithGoogleSession }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
